import { useLang } from "../../i18n/LanguageContext";

const FLAG = { "ampercity.pl": "PL", "efunmotos.com": "ES", "citycoco.hr": "HR", "e-gazia.com": "GR", "electrons.gr": "GR", "riedis-electric.com": "LT", "escooter.com.cy": "CY", "amperi.eu": "PL", "electro.technology": "PL", "hadronenergy.pl": "PL", "arthurtoren.co.uk": "UK", "path.com.pl": "PL", "ultre.city": "PL", "joywo.org": "KE", "smachs.foundation": "KE" };
const host = (u) => u.replace(/^https?:\/\/(www\.)?/, "").replace(/\/.*$/, "");

export const PartnerWall = () => {
  const { t } = useLang();
  const seen = new Set();
  const items = [
    ...t.amperi.proof.map((p) => ({ name: p.name, url: p.url })),
    ...t.group.companies.filter((c) => !c.internal && c.name !== "MargTor Ltd.").map((c) => ({ name: c.name, url: c.url })),
    ...(t.group.supporters || []).map((s) => ({ name: s.name.replace(/ \(.*\)$/, ""), url: s.url })),
  ].filter((it) => !seen.has(host(it.url)) && seen.add(host(it.url)));
  const Tile = ({ it, idx }) => (
    <a
      href={it.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-hidden={idx >= items.length ? "true" : undefined}
      tabIndex={idx >= items.length ? -1 : 0}
      data-testid={idx < items.length ? `partner-wall-${host(it.url).replace(/\W+/g, "-")}` : undefined}
      className="group flex shrink-0 items-center gap-4 border-r border-technical px-7 py-4 transition-colors duration-200 hover:bg-white"
    >
      <span className="chamfer-sm flex h-9 w-9 shrink-0 items-center justify-center border border-technical bg-white font-mono-tech text-[10px] font-semibold text-red-brand group-hover:bg-ink group-hover:text-[#f8f7f4] transition-colors">
        {FLAG[host(it.url)] || "EU"}
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display text-base sm:text-lg font-black tracking-tight text-ink group-hover:text-red-brand transition-colors whitespace-nowrap">{it.name}</span>
        <span className="mt-1 font-mono-tech text-[9.5px] tracking-[0.15em] text-[#9ca3af] whitespace-nowrap">{host(it.url)}</span>
      </span>
    </a>
  );
  return (
    <div className="relative mt-10 overflow-hidden border-y border-technical bg-sand" data-testid="partner-wall">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-sand to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-sand to-transparent" />
      <div className="marquee-track" style={{ animationDuration: "60s" }}>
        {[...items, ...items].map((it, i) => <Tile key={`${it.url}-${i}`} it={it} idx={i} />)}
      </div>
    </div>
  );
};
